import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ProcessSessionService } from '@services/process-route/process-session.service';

@Injectable({
  providedIn: 'root',
})
export class AuthSessionGuard implements CanActivate {
  private readonly processSession: ProcessSessionService = inject(ProcessSessionService);

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.processSession.hasValidIdToken()) {
      return true;
    }

    this.processSession.clearInvalidSession();
    return this.processSession.buildLoginUrlTree(state.url);
  }
}
